<template>
  <div class="suggestion">
    <v-textarea class="textarea" v-model="content" :placeholder="$t(langKey+'.placeholder1')" :tooLongAlert="$t(langKey+'.errorMsg1')"></v-textarea>
    <div class="img-list">
      <div class="title">{{$t(langKey+'.title1')}} ({{imageList.length}}/4)</div>
      <div class="list">
        <div class="img" v-for="(item, i) in imageList" :key="i">
          <label :for="'editImageFile'+i">
            <img :src="item">
            <input class="edit-image-file" type="file" :id="'editImageFile'+i" @change="editImage(i)" accept="image/*">
          </label>
          <i class="del" @click="delImage(i)"></i>
        </div>
        <div class="add" v-if="imageList.length<4">
          <label for.prop="$refs.addImageFile">
            <i class="iconfont icon-plus"></i>
            <input type="file" ref="addImageFile" @change="addImage" accept="image/*">
          </label>
        </div>
      </div>
    </div>
    <div class="contact" v-if="!userInfo.mobile && !userInfo.email">
      <div class="title">
        <div class="left">{{$t(langKey+'.title2')}}</div>
        <label for="anonymousBtn" class="right">
          <input type="checkbox" id="anonymousBtn" v-model="anonymous">
          <i></i>{{$t(langKey+'.button1')}}</label>
      </div>
      <div class="input" v-if="!anonymous">
        <v-input type="text" :placeholder="$t(langKey+'.placeholder2')" v-model="phoneNum" v-if="!isAbroad" @blur="checkPhoneNum"/>
        <v-input type="text" :placeholder="$t(langKey+'.placeholder3')" v-model="email" v-if="isAbroad" @blur="checkEmail"/>
      </div>
    </div>
    <div class="tips" v-if="!anonymous">{{$t(langKey+'.tips')}}</div>
    <div class="tips danger" v-if="anonymous">{{$t(langKey+'.tips2')}}</div>
    <div class="footer">
      <div class="submit">
        <a @click="_sendCode" class="active" v-if="pass">{{$t(langKey+'.button2')}}</a>
        <a v-if="!pass">{{$t(langKey+'.button2')}}</a>
      </div>
      <div class="download" v-if="!isApp && lang === 'zh'">查看意见和奖励情况请下载 <router-link tag="a" to="/download">设备码APP</router-link></div>
      <div class="download" v-if="!isApp && lang === 'en'">Please download the <router-link tag="a" to="/download">Launch EQP</router-link> to view comments and Awards</div>
    </div>
    <captcha v-model="captcha" ref="captcha" :account="contact" :countdown="captchaCountdown" @resend="resendCode"></captcha>
  </div>
</template>
<script type="text/ecmascript-6">
/* eslint-disable */
import Textarea from 'components/textarea'
import { setTitle } from 'components/mixin/title'
import ImageList from 'components/image-list'
import {fileToBase64, base64ToFile} from '@/utils/image'
import vInput from 'components/input'
import Captcha from 'components/captcha'
import { submit } from 'api/equipment'
import { getUrlParam } from '@/utils/utils'
import { sendCode, checkCode } from 'api/equipment'
import { mapGetters } from 'vuex'
import { uploadImage } from 'api/upload'
export default {
  data() {
    return {
      langKey: this.$route.name,
      content: '',
      imageList: [],
      imageUrlList: [],
      // 是否匿名
      anonymous: false,
      // 电话号码
      phoneNum: '',
      // 邮箱
      email: '',
      // 验证码
      captcha: '',
      pass: false,
      captchaCountdown: 60,
      countdownTimer: null
    }
  },
  mixins: [setTitle],
  computed: {
    ...mapGetters(['lang', 'isApp', 'isAbroad', 'userInfo']),
    contact() {
      return this.isAbroad ? this.email : this.phoneNum
    }
  },
  created() {
    this.$nextTick(() => {
      if (this.userInfo.mobile || this.userInfo.email) {
        this.phoneNum = this.userInfo.mobile
        this.email = this.userInfo.email
      }
    })
  },
  methods: {
    addImage() {
      if (!this.$refs.addImageFile.value) return
      this.$loading.open()
      let file = this.$refs.addImageFile.files[0]
      // 获取base64图片
      fileToBase64(file).then(base64 => {
        this.$loading.close()
        let f = base64ToFile(base64, this.$uuid() + '.jpeg')
        uploadImage(f).then(res => {
          this.imageList.push(base64)
          this.imageUrlList.push(res.data.url)
          console.log(res)
          this.$loading.close()
          this.$forceUpdate()
        }).catch(err => {
          console.error(err)
          this.$loading.close()
        })
      })
    },
    editImage(index) {
      console.log(index)
      let inputEl = document.getElementById('editImageFile' + index);
      if (!inputEl.value) return
      this.$loading.open()
      let file = inputEl.files[0]
      fileToBase64(file).then(base64 => {
        this.$loading.close()
        let f = base64ToFile(base64, this.$uuid() + '.jpeg')
        uploadImage(f).then(res => {
          this.imageList[index] = (base64)
          this.imageUrlList[index] = (res.data.url)
          console.log(res)
          this.$loading.close()
          this.$forceUpdate()
        }).catch(err => {
          console.error(err)
          this.$loading.close()
        })
      })
    },
    // 删除图片
    delImage(index) {
      this.imageList.splice(index, 1)
      this.imageUrlList.splice(index, 1)
      this.$forceUpdate()
    },
    // 发送验证码
    _sendCode() {
      // 如果匿名或者已经登陆用户, 不发送验证码
      if (this.anonymous || this.userInfo.mobile || this.userInfo.email) {
        this._submit()
      } else {
        this.captchaCountdown = 60
        clearInterval(this.countdownTimer)
        this.countdownTimer = null
        this.$loading.open()
        sendCode(this.contact).then(res => {
          // 显示验证码输入框
          this.$refs.captcha.open()
          // 成功的提示信息
          this.$toast(this.$t('Captcha.msg1'))
          // 关闭loading
          this.$loading.close()
          // 倒计时
          this.countdownTimer = setInterval(() => {
            this.captchaCountdown--
            if (this.captchaCountdown === 0) {
              this.captchaCountdown = 0
              clearInterval(this.countdownTimer)
              this.countdownTimer = null
            }
          }, 1000)
        }).catch(err => {
          this.$loading.close()
          console.log(err)
          this.$toast(err.msg)
          this.captchaCountdown = 0
          clearInterval(this.countdownTimer)
          this.countdownTimer = null
        })
      }
    },
    resendCode() {
      this._sendCode()
    },
    // 提交
    _submit() {
      this.pass = false
      // window.location.href = 'http://ibs6688.cnlaunch.com/#/extraMyIdea?mobile=15118252171'
      this.$loading.open()
      let data = {
        devicesn: getUrlParam('serial_no'),
        content: this.content,
        contact: this.isAbroad ? this.email : this.phoneNum,
        is_anonymous: this.anonymous ? '1' : '0'
      }
      if (this.imageUrlList.length) {
        this.imageUrlList.forEach((url, index) => {
          data['image' + (index + 1)] = url
        })
      }
      submit(data).then(res => {
        this.pass = true
        this.$toast(this.$t(this.langKey + '.msg'))
        this.data = res
        this.$loading.close()
        setTimeout(() => {
          this.$router.push('/')
        }, 2500)
      }).catch(err => {
        console.log(err)
        this.pass = true
        this.$toast(err.msg)
        this.$loading.close()
      })
    },
    checkForm() {
      // 是否匿名
      if (this.anonymous) {
        if (this.content) {
          this.pass = true
        } else {
          this.pass = false
        }
      } else {
        // 不匿名
        // 判断国内用户还是国外用户
        // 国外
        if (this.isAbroad) {
          let reg = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/
          if (this.content && reg.test(this.email)) {
            this.pass = true
          } else {
            this.pass = false
          }
        } else {
          // 国内用户
          let reg = /^(13[0-9]|14[5-9]|15[0-3,5-9]|16[2,5,6,7]|17[0-8]|18[0-9]|19[1,3,5,8,9])\d{8}$/
          if (this.content && reg.test(this.phoneNum)) {
            this.pass = true
          } else {
            this.pass = false
          }
        }
      }
    },
    _checkCode() {
      this.$loading.open()
      checkCode(this.contact, this.captcha).then(res => {
        // this.$toast(this.$t('Captcha.msg1'))
        this.$loading.close()
        setTimeout(() => {
          this.$refs.captcha.close()
        }, 500)
        // 提交表单
        this._submit()
      }).catch(err => {
        this.$loading.close()
        console.log(err)
        this.$toast(err.msg)
      })
    },
    checkPhoneNum() {
      let reg = /^(13[0-9]|14[5-9]|15[0-3,5-9]|16[2,5,6,7]|17[0-8]|18[0-9]|19[1,3,5,8,9])\d{8}$/
      if (!reg.test(this.phoneNum)) {
        this.$toast(this.$t(this.langKey + '.errorMsg4'))
      }
    },
    checkEmail() {
      let reg = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/
      if (!reg.test(this.email)) {
        this.$toast(this.$t(this.langKey + '.errorMsg4'))
      }
    }
  },
  components: {
    vTextarea: Textarea,
    ImageList,
    vInput,
    Captcha
  },
  watch: {
    captcha(nv) {
      if (nv.length === 4) {
        this._checkCode()
      }
    },
    content() {
      this.checkForm()
    },
    anonymous() {
      this.checkForm()
    },
    phoneNum() {
      this.checkForm()
    },
    email() {
      this.checkForm()
    },
    userInfo(nv) {
      this.phoneNum = nv.mobile
      this.email = nv.email
    }
  },
  beforeDestroy() {
    clearInterval(this.countdownTimer)
    this.countdownTimer = null
  }
}
</script>
<style scoped lang="scss">
  @import "css/def";
  .suggestion {
    min-height: 100vh;
    background: rgba(241, 241, 241, 1);
    padding-bottom: size(32);
    .textarea{
      /deep/ textarea{
      }
    }
    .img-list{
      padding: size(32);
      background-color: #fff;
      margin-top: size(20);
      .title{
        font-size: size(30);
        color: #333333;
        font-weight: 600;
      }
      .list{
        margin-top: size(10);
        @include flex();
        justify-content: flex-start;
        flex-wrap: wrap;
        >div{
          width: size(154);
          height: size(154);
          background-color: #F1F1F1;
          margin-right: size(24);
          margin-top: size(24);
          background-color: #F1F1F1;
          &.add{
            label{
              display: block;
              width: 100%;
              height: 100%;
              position: relative;
              i{
                position: absolute;
                top: 50%;
                left: 50%;
                -webkit-transform: translate(-50%, -50%);
                -moz-transform: translate(-50%, -50%);
                -ms-transform: translate(-50%, -50%);
                -o-transform: translate(-50%, -50%);
                transform: translate(-50%, -50%);
                color: #aaa;
                font-size: size(38);
              }
            }
            input{
              display: none;
            }
          }
          &.img{
            position: relative;
            z-index: 1;
            label{
              display: block;
              position: relative;
              z-index: 2;
              width: 100%;
              height: 100%;
              .edit-image-file{
                display: none;
              }
              img{
                width: 100%;
                height: 100%;
              }
            }
            i{
              position: absolute;
              top: size(-14);
              right: size(-14);
              z-index: 3;
              width: size(40);
              height: size(40);
              display: inline-block;
              -webkit-background-size: 100% 100%;
              background-size: 100% 100%;
              background-repeat: no-repeat;
              background-image: url('~image/icon/del.png');
            }
          }
        }
      }
    }
    .contact{
      margin-top: size(20);
      background-color: #fff;
      padding: size(32);
      .title{
        width: 100%;
        @include flex();
        justify-content: space-between;
        .left{
          font-size: size(30);
          color: #333333;
          font-weight: 600;
        }
        .right{
          color: #999999;
          font-size: size(26);
          input{
            display: none;
          }
          i{
            font-family: "iconfont" !important;
            font-size: size(32);
            font-style: normal;
            -webkit-font-smoothing: antialiased;
            margin-right: size(12);
          }
          input + i{
            &::before{
              content: "\eb94";
            }
          }
          input:checked + i{
            &::before{
              content: "\e656";
            }
          }
        }
      }
      >.input{
        margin-top: size(20);
        /deep/ input{
          font-size: size(30);
          &::placeholder{
            color: #ccc;
          }
        }
      }
    }
    >.tips{
      padding: size(20) size(32);
      font-size: size(24);
      color: #999;
      &.danger{
        color: #ff0000;
      }
    }
    >.footer{
      background-color: #f1f1f1;
      margin-top: size(100);
      >.submit{
        width: 100%;
        text-align: center;
        padding: 0 size(32);
        a{
          display: block;
          width: 100%;
          height: size(94);
          line-height: size(94);
          background-color: #E58B86;
          color: #fff;
          -webkit-border-radius: size(48);
          -moz-border-radius: size(48);
          border-radius: size(48);
          font-size: size(30);
          &.active{
            background-color: #D9251D;
          }
        }
      }
      >.download{
        padding: 0 size(32);
        color: #999;
        font-size: size(24);
        text-align: center;
        margin-top: size(75);
        line-height: 1.4;
        a{
          color: #1889FC;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/equipment/suggestion.vue